import type { SsoMode } from "@/types/api";

/** How each sign-in mode is said in the console. */
export const SSO_MODE_LABEL: Record<SsoMode, string> = {
  mixed: "Password or company directory",
  exclusive: "Company directory only",
};

export const SSO_MODE_OPTIONS = (Object.keys(SSO_MODE_LABEL) as SsoMode[]).map((value) => ({
  value,
  label: SSO_MODE_LABEL[value],
}));
